<template>
  <div>
    <v-card>
      <v-card-text>
        <h2 v-if="!subtitle" class="title mt-4 mb-2">{{ title }}</h2>
        <h3 v-else class="mt-4 mb-2">{{ title }}</h3>
        <AccountValueChart
          :chart-data="datasets"
          :height="200"
          label="Test?"
        ></AccountValueChart>
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
import AccountValueChart from "./AccountValueChart";
import pSBC from "../../plugins/pSBC";
import {mapGetters} from "vuex";

export default {
  components: {
    AccountValueChart
  },
  props: {
    title: {
      type: String,
      default: null
    },
    subtitle: {
      type: Boolean,
      default: false
    },
    btc: {
      type: Object,
      default() {
        return { Bittrex: {}, Binance: {} };
      }
    },
    usd: {
      type: Object,
      default() {
        return { Bittrex: {}, Binance: {} };
      }
    }
  },
  computed: {
    ...mapGetters({
      user: "auth/user"
    }),
    datasets: function() {
      const datasetData = [
        {
          label: "BTC Bittrex",
          borderColor: pSBC(0.2, this.$vuetify.theme.primary),
          backgroundColor: pSBC(0.3, this.$vuetify.theme.primary),
          yAxisID: "BTC",
          fill: false,
          data: Object.keys(this.btc.Bittrex).reduce((data, key) => {
            data.push({ x: key, y: this.btc.Bittrex[key] });
            return data;
          }, [])
        },
        {
          label: "BTC Binance",
          borderColor: pSBC(0.2, this.$vuetify.theme.secondary),
          backgroundColor: pSBC(0.3, this.$vuetify.theme.secondary),
          yAxisID: "BTC",
          fill: false,
          data: Object.keys(this.btc.Binance).reduce((data, key) => {
            data.push({ x: key, y: this.btc.Binance[key] });
            return data;
          }, [])
        },
        {
          label: "BTC Huobi",
          borderColor: pSBC(0.2, this.$vuetify.theme.accent),
          backgroundColor: pSBC(0.5, this.$vuetify.theme.accent),
          yAxisID: "BTC",
          fill: false,
          data: Object.keys(this.btc.Huobi).reduce((data, key) => {
            data.push({ x: key, y: this.btc.Huobi[key] });
            return data;
          }, [])
        },
        {
          label: "USD Bittrex",
          borderColor: this.$vuetify.theme.error,
          backgroundColor: pSBC(0.2, this.$vuetify.theme.error),
          yAxisID: "USD",
          fill: false,
          pointStyle: "triangle",
          data: Object.keys(this.usd.Bittrex).reduce((data, key) => {
            if (this.usd.Bittrex[key] === 0) {
              return data;
            }
            data.push({ x: key, y: this.usd.Bittrex[key] });
            return data;
          }, [])
        },
        {
          label: "USD Binance",
          borderColor: pSBC(0.2, this.$vuetify.theme.error),
          backgroundColor: pSBC(0.3, this.$vuetify.theme.error),
          yAxisID: "USD",
          fill: false,
          pointStyle: "triangle",
          data: Object.keys(this.usd.Binance).reduce((data, key) => {
            if (this.usd.Binance[key] === 0) {
              return data;
            }
            data.push({ x: key, y: this.usd.Binance[key] });
            return data;
          }, [])
        },
        {
          label: "USD Huobi",
          borderColor: pSBC(0.2, this.$vuetify.theme.error),
          backgroundColor: pSBC(0.5, this.$vuetify.theme.error),
          yAxisID: "USD",
          fill: false,
          pointStyle: "triangle",
          data: Object.keys(this.usd.Huobi).reduce((data, key) => {
            if (this.usd.Huobi[key] === 0) {
              return data;
            }
            data.push({ x: key, y: this.usd.Huobi[key] });
            return data;
          }, [])
        }
      ];

      return {
        datasets: datasetData
      };
    }
  }
};
</script>



// WEBPACK FOOTER //
// resources/js/components/dashboard/AccountValueChartWrapper.vue